<div class=" intellisense currencySelect" fxLayout="row">
    <ng-select [items]="currencies" bindLabel="currency_code" bindValue="currency_code" [(ngModel)]="selectedCurrency"
        (ngModelChange)="setCurrency()" [disabled]="disabled">
        <!-- <ng-template ng-label-tmp let-item="item"> -->
        <!-- <img height="15" width="15" [src]="item.avatar" /> -->
        <!-- <b *ngFor="let country of item.countries">{{ country.name }}</b> -->
        <!-- </ng-template> -->
        <ng-template ng-option-tmp let-item="item" let-index="index">
            <!-- <img height="15" width="15" [src]="item.avatar" /> -->
            <b>{{ item.currency_code }}</b>
        </ng-template>
    </ng-select>
</div>